import React from 'react';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";

export default class ModalItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props?.show ?? false
    }
  }

  handleClose = (e) => {
    e.preventDefault();
    this.setState({ show: false });
  }

  handleSuccess = (e) => {
    e.preventDefault();
    this.props.onDelete();
    this.setState({ show: false });
  }

  handleShow = (e) => {
    e.preventDefault();
    const isValid = this.props.validationHandler ? this.props.validationHandler() : true;
    if (isValid) {
      this.setState({ show: true });
    }
  }


  render() {
    return (
      <>
        <button
          className={this.props.btnStyle}
          hidden={this.props.hidden}
          onClick={this.handleShow}
          disabled={this.props.disabled}
        >
          {this.props.btnText}
        </button>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Body>{this.props.text}</Modal.Body>
          <Modal.Footer>
            <button
              className="btn background-rojo-megatone btn-sm"
              onClick={this.handleSuccess}
            >
              Aceptar
            </button>
            <button
              className="btn btn-grey btn-sm"
              onClick={this.handleClose}
            >
              Cerrar
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}